.clear-signature.clear-values-heading {
  align-items: baseline;
}

.clear-values-heading__link-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
}

.clear-signature .clear-values-heading__suffix {
  text-transform: none;
}

.clear-signature .clear-values-heading__word {
  --clear-rest: var(--zy-brand-accent, var(--zy-copper-dark));
  --clear-active: var(--zy-brand-forest, var(--zy-text-strong));
  align-items: baseline;
  color: var(--clear-rest);
}

:root[data-theme="dark"] .clear-values-heading__word {
  --clear-active: var(--zy-brand-gold-light, var(--zy-text-strong));
}

.clear-values-heading__label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.clear-values-heading__letters {
  display: inline-flex;
}

.clear-values-heading__letter {
  color: var(--clear-rest);
}

.clear-values-heading__letter:nth-child(1) {
  --clear-highlight: clear-highlight-c;
}

.clear-values-heading__letter:nth-child(2) {
  --clear-highlight: clear-highlight-l;
}

.clear-values-heading__letter:nth-child(3) {
  --clear-highlight: clear-highlight-e;
}

.clear-values-heading__letter:nth-child(4) {
  --clear-highlight: clear-highlight-a;
}

.clear-values-heading__letter:nth-child(5) {
  --clear-highlight: clear-highlight-r;
}

/* Each letter joins the highlight in turn; all five reset together without changing layout. */
.clear-values-heading__word:focus-visible .clear-values-heading__letter {
  animation: var(--clear-highlight) 3.2s ease-in-out infinite;
}

@media (hover: hover) and (pointer: fine) {
  .clear-values-heading__word:hover .clear-values-heading__letter {
    animation: var(--clear-highlight) 3.2s ease-in-out infinite;
  }
}

/* Touch visitors see one gentle sequence when CLEAR first enters view. */
@media (hover: none) and (prefers-reduced-motion: no-preference) {
  a.clear-values-heading__word[data-clear-pulse="true"] .clear-values-heading__letter {
    animation: var(--clear-highlight) 3.2s ease-in-out 1;
  }
}

@keyframes clear-highlight-c {
  0%,
  85%,
  100% {
    color: var(--clear-rest);
  }
  6%,
  74% {
    color: var(--clear-active);
  }
}

@keyframes clear-highlight-l {
  0%,
  12%,
  85%,
  100% {
    color: var(--clear-rest);
  }
  18%,
  74% {
    color: var(--clear-active);
  }
}

@keyframes clear-highlight-e {
  0%,
  24%,
  85%,
  100% {
    color: var(--clear-rest);
  }
  30%,
  74% {
    color: var(--clear-active);
  }
}

@keyframes clear-highlight-a {
  0%,
  36%,
  85%,
  100% {
    color: var(--clear-rest);
  }
  42%,
  74% {
    color: var(--clear-active);
  }
}

@keyframes clear-highlight-r {
  0%,
  48%,
  85%,
  100% {
    color: var(--clear-rest);
  }
  54%,
  74% {
    color: var(--clear-active);
  }
}

@media (prefers-reduced-motion: reduce) {
  .clear-signature
    .clear-values-heading__word:is(:hover, :focus-visible)
    .clear-values-heading__letter {
    animation: none;
    color: var(--clear-active);
  }
}
